var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormatEnum, } from "../types/Api";
import { API_PATHS } from "../types/apiPaths";
import { getHeaders } from "../utils/apiUtils";
/**
 * Generic helper for POST report generation requests.
 * All report generators share the same pattern — only the path, params type, and options differ.
 *
 * A file report is accepted as a background job: the backend answers HTTP 202
 * with {@link ReportJobStarted} at once and the caller polls it (see
 * `useReportJob`), so no long request timeout is needed. The on-screen reports
 * (annual, SČKN, IPA, WIPO, Kult 15-01 preview) are answered with their data.
 */
var postReport = function (ky, path, params, options) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.post(path, __assign({ headers: getHeaders(), json: params }, options))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Report error: ".concat(response.status));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var generateProgressReport = function (ky, params, format) {
    return postReport(ky, API_PATHS.REPORTS_PROGRESS_REPORT, params, {
        searchParams: { format: format },
    });
};
export var generatePiidReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_PIID_REPORT, params, {
        searchParams: { format: FormatEnum.CSV },
    });
};
export var generateIdentifierReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_IDENTIFIER_REPORT, params);
};
export var generateAnnualReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_ANNUAL_REPORT, params);
};
export var generateScknReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_SCKN_REPORT, params);
};
export var generateKult1501Report = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_15_01, params);
};
export var generateKult1501Xlsx = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_15_01_EXPORT, params, {
        searchParams: { format: FormatEnum.XLSX },
    });
};
export var generateIpaReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_IPA_REPORT, params);
};
export var generateNiposReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_NIPOS_REPORT, params, {});
};
export var generateOnixExport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_ONIX_EXPORT, params, {});
};
export var generatePerformanceStatisticsReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_PERFORMANCE_STATISTICS, params, {});
};
export var generateWipoReport = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_WIPO_REPORT, params);
};
